import { useMemo } from 'react'
import { useMount } from 'ahooks'
import Udb from '@yy/oneship-udb'
import { UDB_CONF } from '../constants'
import { useTranslation } from 'react-i18next'
import { Dialog, Toast } from 'antd-mobile'
import Cookies from 'js-cookie'
import { check2fa } from '@/services/bff/info/api'
import { useUserLogin } from '@/components/Authorized/hooks'
// 所有需要全局通知的都放这里

const pwdSafeUdb = Udb.pwdSafe(UDB_CONF)

/**
 * 密码有效期判断提示
 * @param notification
 */
const usePasswordExpiredNotif = (notification: () => void) => {
  const uid = useMemo(() => Cookies.get('osudb_uid'), [])

  useMount(async () => {
    if (!uid) return
    // 通知提示
    const pwdRes = await pwdSafeUdb.queryPopup({ uid, ticketType: '1' })
    const day = Math.ceil(pwdRes.data.pwdRemainingTime / (24 * 3600 * 1000))

    if (day < 30 && ![30, 15, 7, 1].includes(day)) {
      notification()
    }
  })
}

/**
 * 密码有效期判断提示
 */
const useMobilePasswordExpiredNotif = () => {
  const { t } = useTranslation()

  usePasswordExpiredNotif(() => {
    Toast.show(t('passwordExpired.noti.title'))
  })
}

const use2faNotif = (notification: () => void) => {
  const uid = useMemo(() => Cookies.get('osudb_uid'), [])
  useMount(async () => {
    if (!uid) return
    const res = await check2fa()
    // 没开启2fa并且账号要求开启
    if (!res.enabled && res.twoFactorAuthPolicy === 1) {
      notification()
    }
  })
}

const useMobile2faNotif = () => {
  const { t } = useTranslation()
  const { logoutToOnclub } = useUserLogin()
  use2faNotif(() => {
    Dialog.alert({
      title: t('login.please.relogin'),
      content: t('login.please.relogin.desc'),
      onConfirm: logoutToOnclub,
      confirmText: t('go.login'),
    })
  })
}

/**
 * h5所有全局提示
 */
export const useMobileNotif = () => {
  useMobilePasswordExpiredNotif()
  useMobile2faNotif()
}
